import React, { memo } from "react";
import { TableRowLayout } from "../../template/table/TableRowLayout";
import { Badge, Box, CardBody, CardFooter, CardHeader } from "@chakra-ui/react";
import { TableLayout } from "../../template/table/TableLayout";
import { CircularLoading } from "../../molecules/loading/CircularLoading";
import { useFetchKuchikomyuSurveyQuestionsByRestaurantId } from "../../../hooks/kuchikomyu/useFetchKuchikomyuSurveyQuestionsByRestaurantId";
import { PageTransitionBtn } from "../../atoms/button/PageTransitionBtn";
import { KuchikomyuSurveyQuestionDeleteModal } from "../../organisms/kuchikomyu/KuchikomyuSurveyQuestionDeleteModal";
import { useParams } from "react-router-dom";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { RiFileTextLine } from "react-icons/ri";


export const KuchikomyuSurveyQuestions: React.FC = memo(() => {
  const { restaurantId } = useParams()
  const { surveyQuestions, isLoading } = useFetchKuchikomyuSurveyQuestionsByRestaurantId(restaurantId)
  if (!restaurantId || isLoading || !surveyQuestions) return <CircularLoading />
  const headers = ['質問', '回答数', ''];
  const rows = surveyQuestions.map((surveyQuestion) => (
    <TableRowLayout
      key={surveyQuestion.id}
      childrenList={[
        surveyQuestion.question,
        surveyQuestion.answer_count,
        surveyQuestion.is_selected ? (
          <Badge colorScheme='green'>使用中</Badge>
        ) : (
          <KuchikomyuSurveyQuestionDeleteModal id={surveyQuestion.id} mutateKey={`kuchikomyu/restaurants/${restaurantId}/survey/questions/`} restaurantName={surveyQuestion.question} />
        )
      ]}
    />
  ));
  return (
    <Box m='auto' w={{ base: '100%', md: '80%' }}>
      <DarkShadowCard>
        <CardHeader>
          <CardHeading icon={<RiFileTextLine size="20px" />} heading='アンケート一覧'/>
        </CardHeader>
        <CardBody py={2}>
          <TableLayout headers={headers} rows={rows || []} size='sm' />
        </CardBody>
        <CardFooter>
          <PageTransitionBtn path={'register'} text="新規登録" />
        </CardFooter>
      </DarkShadowCard>
    </Box>
  );
});